// @core/api/endpoints/billing/create_journal_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateJournalEntryRequest,
  CreateJournalEntryResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create journal entry
 * Creates a new journal entry with debit and credit lines. The entry must be balanced before it can be posted to the general ledger.
 */
export async function CreateJournalEntry(
  data: CreateJournalEntryRequest,
  options?: RequestOptions
): Promise<CreateJournalEntryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/journal-entries`;
  const requestOptions = options;
  return client.post<CreateJournalEntryResponse>(requestPath, data, requestOptions);
}
